import menu from './menu';
import auth from './auth';
import api from './api';
import tenancy from "./tenancy";
// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = { menu, tenancy, auth, ...api };

export default reducers;
